document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeSection_FullScreenPopup", (settings) => {
    return {
      delay: settings.delay,
      enabled: settings.enabled,
      sectionId: settings.sectionId,
      mounted() {
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === "/challenge") return;
        initTeleport(this.$root);
        Alpine.store("modals").register("fullscreenPopup", "cover");

        if (!Shopify.designMode) {
          setTimeout(() => {
            this.open();
            const escapeHandler = (e) => {
              if (e.code.toUpperCase() !== "ESCAPE") return;
              this.$store.modals.close("fullscreenPopup");
              document.body.removeEventListener("keydown", escapeHandler);
            };
            document.body.addEventListener("keydown", escapeHandler);
          }, this.delay * 1000);
        } else {
          if (window.theme.designMode.selected === this.sectionId) {
            if (this.enabled === true) {
              this.open();
            } else {
              // It might be open from a previous instantiation
              Alpine.store("modals").close("fullscreenPopup");
            }
          }
          document.addEventListener("shopify:section:select", (e) => {
            if (!e.target.contains(this.$root)) return;
            if (!this.enabled) return;
            this.open();
          });
          document.addEventListener("shopify:section:deselect", (e) => {
            if (!e.target.contains(this.$root)) return;
            this.$store.modals.close("fullscreenPopup");
          });
        }
      },
      open() {
        this.$store.modals.open("fullscreenPopup");
        this.$focus.first();
      },
    };
  });
});
